import barangayReducer from './barangaySlice';
import * as barangayActions from './actions';
import * as barangaySelector from './selector';

export {
  barangayActions,
  barangaySelector
}

export default barangayReducer